import React, {useCallback, useEffect, useState, useRef} from 'react';
import 'reactflow/dist/style.css';
import {useParams} from 'react-router-dom';
import {
    Button,
    Col as AntdCol,
    Form, Image,
    Input,
    notification,
    Popconfirm,
    Radio,
    Row as AntdRow,
    Select,
    Switch,
    Tooltip
} from 'antd';
import {
    createBranchFromStep, createLinkFromStep, createMultiStepFromStep, createOptionFromStep, createSceneFromStep,
    createStepFromStep, deleteLink, deleteOption, deleteScene,
    deleteStep, getEpisodeBackgrounds,
    getEpisodeById,
    getScenesByEpisodeId, sortScenes, updateOption,
    updateScene,
    updateStep
} from '../../helpers/api/episode';
import './EpisodeDetail.scss';
import {
    applyEdgeChanges,
    applyNodeChanges,
    Background,
    BackgroundVariant,
    Controls,
    Edge, EdgeChange,
    MiniMap,
    Node,
    NodeChange, NodePositionChange,
    ReactFlow
} from 'reactflow';
import {PictureOutlined, SkinOutlined, SoundOutlined} from "@ant-design/icons";
import CustomNode from "./CustomNode";
import {Modal} from "react-bootstrap";
import {Icon} from "ts-react-feather-icons";
import {getStoryCharacters} from "../../helpers/api/story";
import OutfitSelectionModal from "./OutfitSelectionModal";
import BackgroundSelectionModal from "./BackgroundSelectionModal";
import {searchSounds} from '../../helpers/api/sound';
import SoundSelectionModal from "./SoundSelectionModal";
import narationIcon from '../../assets/images/narration.svg';
import buttonNext from '../../assets/images/button-next.png';
import buttonLose from '../../assets/images/button-lose.png';
import buttonFinish from '../../assets/images/button-finish.png';
import thoughtIcon from '../../assets/images/thought.png';

interface SceneModel {
    id: string;
    episodeId: string;
    name: string;
    type: string;
    position: string;
    steps: StepModel[];
    link?: {
        idFrom: string;
        idTo: string;
        typeNext: string;
        nameNext: string;
    }
    isActivated: boolean;
}

interface StepModel {
    id: string;
    episodeId: string;
    sceneId: string;
    type: string;
    content: string;
    backgroundId: string;
    soundId: string;
    ownerId: string;
    outfitItemId: string;
    outfitItem?: {
        id: string;
        name: string;
        imageUrl: string;
    }
    isThought: boolean
    isStarting: boolean;
    isEnding: boolean;
    isWinning: boolean;
    options: OptionModel[];
    isUpdate: boolean;
}

interface OptionModel {
    id: string;
    stepId: string;
    type: string;
    content: string;
    nextStepId: string;
    isUpdate: boolean;
}

interface NodeModel extends SceneModel {
    label: string;
}

interface EdgeModel extends OptionModel {
    source: string;
    target: string;
}

const nodeTypes = {
    custom: CustomNode,
};

function EpisodeDetail() {
    const {episodeId} = useParams();
    const [characters, setCharacters] = useState<any[]>([]);
    const [typeStepOptions, setTypeStepOptions] = useState<any[]>([]);
    const [nodes, setNodes] = useState<Node<NodeModel>[]>([]);
    const [edges, setEdges] = useState<Edge<EdgeModel>[]>([]);
    const [sceneDetail, setSceneDetail] = useState<SceneModel | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [stepIdActive, setStepIdActive] = useState<string | null>(null);
    const [stepActive, setStepActive] = useState<StepModel | null>(null);
    const [backgroundUrlCurrent, setBackgroundUrlCurrent] = useState<string>('');

    const [previewEpisode, setPreviewEpisode] = useState<boolean>(false);


    const [openOutfitPopup, setOpenOutfitPopup] = useState(false);
    const [selectedCharacterId, setSelectedCharacterId] = useState<string>('');


    const [openBackgroundPopup, setOpenBackgroundPopup] = useState(false);
    const [episodeBackgrounds, setEpisodeBackgrounds] = useState<any>([]);

    const [openSoundPopup, setOpenSoundPopup] = useState(false);
    const [sounds, setSounds] = useState<any>([]);

    const [showSaveButton, setShowSaveButton] = useState<boolean>(false);
    const [scenePositions, setScenePositions] = useState<{
        id: string,
        position: string
    }[]>([]);

    const [openDeleteBranchModal, setOpenDeleteBranchModal] = useState<boolean>(false);
    const [branchDeleteId, setBranchDeleteId] = useState<string>('');
    const [optionNotDeleteId, setOptionNotDeleteId] = useState<string>('');

    const [openLinkModal, setOpenLinkModal] = useState(false);
    const [selectedLinkTarget, setSelectedLinkTarget] = useState<string>('');


    const [api, contextHolder] = notification.useNotification();

    const sidebarRef = useRef<HTMLDivElement>(null);

    const [openEditScene, setOpenEditScene] = useState<boolean>(false);

    const [openAddScriptModal, setOpenAddScriptModal] = useState<boolean>(false);

    const triggerUpdateScene = () => {
        form.setFieldsValue({...sceneDetail});
        setOpenEditScene(true);
    }

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);

    const [submittables, setSubmittable] = useState<boolean>(false);

    useEffect(() => {
        form.validateFields({validateOnly: true})
            .then(
                () => {
                    setSubmittable(true)
                },
                () => {
                    setSubmittable(false)
                },
            );
    }, [formValueObj]);

    useEffect(() => {
            if (characters.length === 0) return;
            const options = characters.map((character) => ({
                label: character.name,
                value: character.id,
                icon: <img src={character.avatarUrl} alt={character.name} style={{width: 12, height: 12}}/>,
            }));
            options.unshift({label: 'Narration', value: 'narration', icon: <Icon name="message-square" size={12}/>});
            options.unshift({label: 'User', value: 'user', icon: <Icon name="user" size={12}/>});
            setTypeStepOptions(options);
        }
        , [characters]);

    useEffect(() => {
        if (stepIdActive) {
            const step = sceneDetail?.steps.find((step) => step.id === stepIdActive);
            if (step) {
                if (step.backgroundId) {
                    setBackgroundUrlCurrent(episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl.replaceAll(' ', '%20') as string);
                }
                setStepActive(step);
            }
        }
    }, [stepIdActive, sceneDetail]);

    const showError = useCallback((errorMessage: string) => {
        api.error({
            message: 'Error notification',
            description: (
                <span className="text-danger">
                    {errorMessage || "There're some errors occurred!"}
                </span>
            ),
            placement: 'topRight',
        });
    }, [api]);

    const onNodesChange = useCallback((changes: NodeChange[]) => {
        const positionChanged = changes.some(change => change.type === 'position');
        if (positionChanged) {
            setShowSaveButton(true);
            const changesPosition = changes.filter(change => change.type === 'position');
            for (const change of changesPosition) {
                const changePosition = change as NodePositionChange;
                if (!changePosition.position) {
                    continue;
                }
                setScenePositions((prevScenePositions) => {
                    // Lọc bỏ tất cả bản ghi cũ có cùng id
                    const filteredPositions = prevScenePositions.filter(node => node.id !== changePosition.id);

                    // Thêm hoặc cập nhật bản ghi mới
                    return [
                        ...filteredPositions,
                        {
                            id: changePosition.id,
                            position: JSON.stringify(changePosition.position)
                        }
                    ];
                });
            }


        }
        setNodes((nds) => applyNodeChanges(changes, nds));
    }, []);


    const onEdgesChange = useCallback((changes: EdgeChange[]) => {
        setEdges((eds) => applyEdgeChanges(changes, eds) as {
            id: string;
            source: string;
            target: string;
            label: React.ReactNode
        }[]);
    }, []);

    const fetchData = useCallback(async (sceneId?: string) => {
        if (!episodeId) return;

        try {
            const [episodeRes, scenesRes, episodeBackgroundRes, soundRes] = await Promise.all([
                getEpisodeById(episodeId as string),
                getScenesByEpisodeId(episodeId as string),
                getEpisodeBackgrounds(episodeId as string, {
                    pageIndex: 0,
                    pageSize: 1000
                }),
                searchSounds({
                    pageIndex: 0,
                    pageSize: 1000
                })
            ]);

            setEpisodeBackgrounds(episodeBackgroundRes.data.data);
            setSounds(soundRes.data.data);
            const searchObj: any = {
                pageIndex: 0,
                pageSize: 1000
            };
            const characterRes = await getStoryCharacters(episodeRes.data.storyId, searchObj);
            setCharacters(characterRes.data.data);

            const scenes = scenesRes.data;
            const steps = scenes.flatMap((scene: SceneModel) => scene.steps);
            const optionsRes = steps.flatMap((step: StepModel) => step.options);
            const options = optionsRes.filter((option: OptionModel) => option.type !== 'link');
            const links = optionsRes.filter((option: OptionModel) => option.type === 'link');
            const linkNextTo = links.map((link: OptionModel) => {
                const step = steps.find((step: StepModel) => step.id === link.stepId);
                const scene = scenes.find((scene: SceneModel) => scene.id === step?.sceneId);
                const nextStep = steps.find((step: StepModel) => step.id === link.nextStepId);
                const nextScene = scenes.find((scene: SceneModel) => scene.id === nextStep?.sceneId);
                return {
                    idFrom: scene?.id,
                    idTo: nextScene?.id,
                    nameNext: nextScene?.name,
                    typeNext: nextScene?.type === 'normal' ? 'Scene' : 'Branch',
                }
            });
            const nodes: Node<NodeModel>[] = scenes.map((scene: SceneModel) => ({
                id: scene.id,
                data: {
                    label: scene.name,
                    ...scene,
                    link: linkNextTo.find((link: any) => link.idFrom === scene.id),
                },
                position: scene.position ? JSON.parse(scene.position) as { x: number, y: number } : {x: 0, y: 0},
                type: 'custom',
            }));

            // tìm kiếm những option có nextStepId không cùng scene với step chứa option đó
            const invalidOptions = options.filter((option: OptionModel) => {
                const step = steps.find((step: StepModel) => step.id === option.stepId);
                const nextStep = steps.find((step: StepModel) => step.id === option.nextStepId);
                return step?.sceneId !== nextStep?.sceneId;
            });
            const edges: Edge[] = invalidOptions.map((option: OptionModel) => ({
                id: option.id,
                source: steps.find((step: StepModel) => step.id === option.stepId)?.sceneId as string,
                target: steps.find((step: StepModel) => step.id === option.nextStepId)?.sceneId as string,
                animated: false,
                type: 'smoothstep',
                label: option.content,
                data: option,
            }));
            setNodes(nodes);
            setEdges(edges);
            if (sceneId) {
                const scene = scenes.find((scene: SceneModel) => scene.id === sceneId);
                if (scene) {
                    setSceneDetail({
                        ...scene,
                        link: linkNextTo.find((link: any) => link.idFrom === scene.id),
                    });
                }
            } else {
                const stepIsStarting = steps.find((step: StepModel) => step.isStarting);
                if (stepIsStarting) {
                    const sceneSet = scenes.find((scene: SceneModel) => scene.id === stepIsStarting.sceneId);
                    setSceneDetail(
                        {
                            ...sceneSet,
                            link: linkNextTo.find((link: any) => link.idFrom === sceneSet.id),
                        }
                    );
                } else {
                    setSceneDetail(
                        {
                            ...scenes[0],
                            link: linkNextTo.find((link: any) => link.idFrom === scenes[0].id),
                        }
                    );
                }
            }
        } catch (err) {
            console.error(err);
            showError(err instanceof Error ? err.message : 'Unknown error');
        } finally {
            setLoading(false);
        }
    }, [episodeId]);


    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        setNodes((nds) => nds.map((node) => {
                if (node.id === sceneDetail?.id) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            isActivated: true,
                        }
                    };
                }
                return {
                    ...node,
                    data: {
                        ...node.data,
                        isActivated: false,
                    }
                };
            }
        ));
    }, [sceneDetail]);

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    // Hàm xử lý thay đổi step
    const handleStepChange = (stepId: string, field: string, value: any) => {

        setSceneDetail((prev) => {
                if (!prev) return prev;

                const newSteps = prev.steps.map((step) => {
                    if (step.id === stepId) {
                        if (field === 'type' && value !== 'narration' && value !== 'user') {
                            return {
                                ...step,
                                ownerId: value,
                                type: 'ai',
                                isUpdate: true,
                            };
                        }
                        if (field === 'outfitItem') {
                            return {
                                ...step,
                                outfitItemId: value ? value.id : null,
                                outfitItem: value ? {
                                    id: value.id,
                                    name: value.name,
                                    imageUrl: value.imageUrl,
                                } : {
                                    id: '',
                                    name: '',
                                    imageUrl: '',
                                },
                                isUpdate: true,
                            };
                        }
                        return {
                            ...step,
                            [field]: value,
                            isUpdate: true,
                        };
                    }

                    return step;
                });

                return {
                    ...prev,
                    steps: newSteps,
                };
            }
        );
    }

    // Hàm lưu step
    const handleSaveStep = async (stepId: string) => {
        if (!sceneDetail) return;
        const step = sceneDetail?.steps.find((step) => step.id === stepId);
        if (!step) return;
        const response = await updateStep(episodeId as string, sceneDetail.id, stepId, step);
        if (response?.status === 200) {
            const newSceneDetail = {...sceneDetail};
            newSceneDetail.steps = newSceneDetail.steps.map((step) => {
                if (step.id === stepId) {
                    return {
                        ...step,
                        isUpdate: false,
                    };
                }
                return step;
            });
            setSceneDetail(newSceneDetail);
            await fetchData(sceneDetail.id);
            notification.success({
                message: 'Success',
                description: 'Step saved successfully',
            });
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to save step',
            });
        }

    }

    const handleDeleteStep = async (stepId: string) => {
        if (!sceneDetail) return;
        const res = await deleteStep(episodeId as string, sceneDetail.id, stepId);
        if (res?.status === 200) {
            await fetchData(sceneDetail.id);
        }

    }

    const addStep = async (currentStepId?: string) => {
        if (!sceneDetail) return;
        if (!currentStepId) {
            currentStepId = sceneDetail.steps[sceneDetail.steps.length - 1].id;
        }
        const response = await createStepFromStep(episodeId as string, sceneDetail.id, currentStepId);
        if (response?.status === 200) {
            await fetchData(sceneDetail.id);

        }
    }


    const saveScene = async () => {
        try {
            if (!sceneDetail) return;
            await form.validateFields();
            let response;
            const requestModel: any = {
                name: formValueObj.name?.trim(),
            }
            response = await updateScene(episodeId as string, sceneDetail?.id, requestModel);

            if (response?.status === 200) {
                setOpenEditScene(false);
                await fetchData(sceneDetail.id);
                return;
            }
        } catch (err) {
            console.log(err);
        }
    }

    const addScene = async (currentStepId?: string) => {
        if (!sceneDetail) return;
        if (!currentStepId) {
            currentStepId = sceneDetail.steps[sceneDetail.steps.length - 1].id;
        }
        const response = await createSceneFromStep(episodeId as string, sceneDetail.id, currentStepId);
        if (response?.status === 200) {
            const newScene = response.data;
            await fetchData(newScene.id);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to add scene',
            });
        }
    }

    const addBranch = async (currentStepId?: string) => {
        if (!sceneDetail) return;
        if (!currentStepId) {
            currentStepId = sceneDetail.steps[sceneDetail.steps.length - 1].id;
        }
        const response = await createBranchFromStep(episodeId as string, sceneDetail.id, currentStepId);
        if (response?.status === 200) {
            const newBranch = response.data;
            await fetchData(newBranch.id);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to add branch',
            });
        }
    }

    const handleDeleteScene = async (sceneId: string, optionId?: string) => {
        const res = await deleteScene(episodeId as string, sceneId, {
            optionId: optionId ? optionId : null
        });
        if (res?.status === 200) {
            await fetchData();
        }
    }

    const addOption = async () => {
        if (!sceneDetail) return;

        const currentStepId = sceneDetail.steps[sceneDetail.steps.length - 1].id;

        const response = await createOptionFromStep(episodeId as string, sceneDetail.id, currentStepId);
        if (response?.status === 200) {
            await fetchData(sceneDetail.id);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to add option',

            });
        }
    }

    const handleDeleteOption = async (optionId: string) => {
        if (!sceneDetail) return;
        const step = sceneDetail?.steps[0];
        if (!step) return;
        const res = await deleteOption(episodeId as string, sceneDetail.id, step.id, optionId);
        if (res?.status === 200) {
            await fetchData(sceneDetail.id);
        }
    }

    const handleOptionChange = (optionId: string, field: string, value: any) => {
        setSceneDetail((prev) => {
            if (!prev) return prev;

            const newSteps = prev.steps.map((step) => {
                const newOptions = step.options.map((option) => {
                    if (option.id === optionId) {
                        return {
                            ...option,
                            [field]: value,
                            isUpdate: true,
                        };
                    }
                    return option;
                });
                return {
                    ...step,
                    options: newOptions,
                };
            });

            return {
                ...prev,
                steps: newSteps,
            };
        });
    }

    const handleSaveOption = async (optionId: string) => {
        if (!sceneDetail) return;
        const step = sceneDetail?.steps[0];
        if (!step) return;
        const option = step.options.find((option) => option.id === optionId);
        if (!option) return;
        const response = await updateOption(episodeId as string, sceneDetail.id, step.id, option.id, option);
        if (response?.status === 200) {
            const newSceneDetail = {...sceneDetail};
            newSceneDetail.steps = newSceneDetail.steps.map((step) => {
                const newOptions = step.options.map((option) => {
                    if (option.id === optionId) {
                        return {
                            ...option,
                            isUpdate: false,
                        };
                    }
                    return option;
                });
                return {
                    ...step,
                    options: newOptions,
                };
            });
            setSceneDetail(newSceneDetail);
            await fetchData(sceneDetail.id);
            notification.success({
                message: 'Success',
                description: 'Option saved successfully',
            });
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to save option',
            });
        }

    }

    const addLink = async (currentStepId?: string, targetSceneId?: string) => {
        if (!sceneDetail || !targetSceneId) return;
        if (!currentStepId) {
            currentStepId = sceneDetail.steps[sceneDetail.steps.length - 1].id;
        }
        const targetScene = nodes.find((node) => node.id === targetSceneId);
        const targetStep = targetScene?.data.steps[0];
        if (!targetStep) return;
        const data = {
            nextStepId: targetStep.id,
        }
        const response = await createLinkFromStep(episodeId as string, sceneDetail.id, currentStepId, data);
        if (response?.status === 200) {
            await fetchData(sceneDetail.id);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to add link',
            });
        }
    }

    const handleDeleteLink = async () => {
        if (!sceneDetail) return;
        const res = await deleteLink(episodeId as string, sceneDetail.id);
        if (res?.status === 200) {
            await fetchData(sceneDetail.id);
        }
    }


    const handleUpdatePosition = async () => {
        //loại bỏ những node không còn tồn tại
        const nodeIds = nodes.map(node => node.id);
        const requestModel = scenePositions.filter(node => nodeIds.includes(node.id));

        const response = await sortScenes(episodeId as string, requestModel.map(node => {
            return {
                id: node.id,
                position: node.position
            }
        }));
        if (response.status === 200) {
            setShowSaveButton(false);
            api.success({
                message: `Successfull notification`,
                description: 'Update scenes successfully!',
                placement: 'topRight'
            });
        } else {
            showError(response.data);
        }
    };

    const triggerAddScript = () => {
        form.setFieldsValue({content: ''});
        setOpenAddScriptModal(true);
    }

    const addScript = async () => {
        if (!sceneDetail) return;
        if (!stepIdActive) return;
        let requestModel: any = [];
        if (formValueObj.content) {
            const lines = formValueObj.content.split('\n');
            lines.forEach((line: string) => {
                const dialogueRegex = /^@([\w\s]+);(.+)$/;
                const match = line.match(dialogueRegex);
                if (match) {
                    const character = match[1].trim();
                    const content = match[2].trim();
                    if (character !== 'user') {
                        const char = characters.find((char) => char.name === character);
                        if (char) {
                            requestModel.push({
                                type: "ai",
                                ownerId: char.id,
                                content: content
                            });
                        } else {
                            requestModel.push({
                                type: "narration",
                                content: content,
                                ownerId: null
                            });
                        }
                    } else {
                        requestModel.push({
                            type: "user",
                            content: content,
                            ownerId: null
                        });
                    }
                } else {
                    requestModel.push({
                        type: "narration",
                        content: line,
                        ownerId: null
                    });
                }

            });
        }
        const response = await createMultiStepFromStep(episodeId as string, sceneDetail.id, stepIdActive, requestModel);
        if (response?.status === 200) {
            await fetchData(sceneDetail.id);
            setOpenAddScriptModal(false);
            notification.success({
                message: 'Success',
                description: 'Script added successfully',
            });
        } else {
            showError(response?.data);
        }

    }


    return (
        <div className="appContainer">
            {contextHolder}

            {previewEpisode && stepActive &&
                <div
                    style={{
                        top: "10%",
                        backgroundImage: `url(${backgroundUrlCurrent})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        width: "30%",
                        height: "80%",
                        position: "relative"
                    }}
                >

                    {(stepActive.type === 'ai') &&
                        <div style={{
                            position: "absolute",
                            top: "55%",
                            left: "30%",
                            width: "60%",
                            height: "70%",
                            transform: "translate(-50%, -50%)",
                            background: `url(${stepActive.outfitItem?.imageUrl}) -0.705px 0px / 100.098% 100.951% no-repeat` || "none",
                        }}>
                            <div
                                style={{
                                    position: "absolute",
                                    background: stepActive.isThought ? `url(${thoughtIcon}) 0% 0% / 100% 100% no-repeat` : `url(${narationIcon}) 0% 0% / 100% 100% no-repeat`,
                                    fill: "#FFE9CF",
                                    stroke: "#F90",
                                    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
                                    top: "40%",
                                    left: "100%",
                                    transform: "translate(-50%, -50%)",
                                    width: "90%",
                                    height: "40%"
                                }}
                            >
                                <span style={{
                                    position: "absolute",
                                    top: "38%",
                                    left: "5%"
                                }}>
                                    {stepActive.content}
                                </span>
                            </div>
                            <div
                                style={{
                                    position: "absolute",
                                    top: "30%",
                                    left: "90%",
                                    width: "max-content",
                                    borderRadius: "5px",
                                    background: "#FFF",
                                }}
                            >
                                {characters.find((char) => char.id === stepActive.ownerId)?.name}
                            </div>
                        </div>
                    }

                    {(stepActive.type === 'user') &&
                        <div style={{
                            position: "absolute",
                            top: "55%",
                            left: "70%",
                            width: "60%",
                            height: "70%",
                            transform: "translate(-50%, -50%)",
                            background: `url(${stepActive.outfitItem?.imageUrl}) -0.705px 0px / 100.098% 100.951% no-repeat` || "none",
                        }}>
                            <div
                                style={{
                                    position: "absolute",
                                    background: stepActive.isThought ? `url(${thoughtIcon}) 0% 0% / 100% 100% no-repeat` : `url(${narationIcon}) 0% 0% / 100% 100% no-repeat`,
                                    fill: "#FFE9CF",
                                    stroke: "#F90",
                                    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
                                    backgroundSize: "cover",
                                    top: "40%",
                                    transform: "translate(-50%, -50%) scaleX(-1)",
                                    width: stepActive.isThought ? "100%" : "105%",
                                    height: stepActive.isThought? "30%" : "22%"
                                }}
                            >
                                <span style={{
                                    position: "absolute",
                                    top: stepActive.isThought ? "40%" : "30%",
                                    right: "5%",
                                    transform: "scaleX(-1)"
                                }}>
                                    {stepActive.content}
                                </span>
                            </div>
                        </div>
                    }

                    {stepActive.type == 'narration' && (
                        <div
                            style={{
                                position: "absolute",
                                top: "40%",
                                left: "5%",
                                width: "90%",
                                height: "20%",
                                borderRadius: "20px",
                                border: "2px solid #EA8318",
                                background: "#FFE9CF",
                                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.25) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                            }}
                        >
                            <span style={{
                                position: "absolute",
                                top: "10%",
                                left: "5%"
                            }}>
                                {stepActive.content}
                            </span>
                        </div>
                    )}

                    {sceneDetail?.type === 'normal' ? (
                        <>
                            {!stepActive.isEnding ? (
                                <div
                                    style={{
                                        background: `url(${buttonNext}) 0% 0% / 100% 100% no-repeat`,
                                        position: "absolute",
                                        top: "90%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "100px",
                                        height: "50px"
                                    }}

                                    onClick={() => {
                                        setStepIdActive(stepActive.options[0].nextStepId);
                                        const stepNext = nodes.map((node) => node.data.steps).flat().find((step) => step.id === stepActive.options[0].nextStepId);
                                        if (stepNext?.sceneId !== sceneDetail?.id) {
                                            const sceneNext = nodes.find((node) => node.id === stepNext?.sceneId);
                                            if (sceneNext) {
                                                setSceneDetail(sceneNext.data);
                                            }
                                        }

                                    }}
                                >

                                </div>
                            ) : (
                                <>
                                    {!stepActive.isWinning ? (
                                        <div
                                            style={{
                                                background: `url(${buttonLose}) 0% 0% / 100% 100% no-repeat`,
                                                position: "absolute",
                                                top: "90%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: "100px",
                                                height: "50px"
                                            }}
                                        >

                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                background: `url(${buttonFinish}) 0% 0% / 100% 100% no-repeat`,
                                                position: "absolute",
                                                top: "90%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: "100px",
                                                height: "50px"
                                            }}
                                        >

                                        </div>
                                    )}
                                </>
                            )}
                        </>


                    ) : (
                        <div
                            style={{
                                position: "absolute",
                                top: "70%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "200px",
                                height: "50px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",

                            }}
                        >
                            {
                                stepActive.options.map((option) => (
                                    <div
                                        key={option.id}
                                        style={{
                                            background: "#EA8318",
                                            borderRadius: "15px",
                                            marginTop: "20px",
                                            padding: "10px",
                                            marginBottom: "5px",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            setStepIdActive(option.nextStepId);
                                            const stepNext = nodes.map((node) => node.data.steps).flat().find((step) => step.id === option.nextStepId);
                                            if (stepNext?.sceneId !== sceneDetail?.id) {
                                                const sceneNext = nodes.find((node) => node.id === stepNext?.sceneId);
                                                if (sceneNext) {
                                                    setSceneDetail(sceneNext.data);
                                                }
                                            }
                                        }}
                                    >
                                        {option.content}
                                    </div>
                                ))
                            }


                        </div>
                    )}
                    <Button
                        style={{
                            position: "absolute",
                            top: "-10%",
                            right: "0%",
                            color: "blue"
                        }}
                        type="default"
                        shape="round"
                        onClick={() => setPreviewEpisode(false)}

                    >
                        {"<< Back"}
                    </Button>


                </div>

            }
            <div className="sidebar" ref={sidebarRef}>
                {sceneDetail && sceneDetail.type === 'normal' && (
                    <div className="detailContainer">
                        <div className="scene-header">
                            <div className="scene-info">
                                <h2 className="title">{sceneDetail.name}</h2>
                            </div>
                            <div className="scene-actions">
                                <Tooltip title="Update">
                                    <button
                                        onClick={() => triggerUpdateScene()}
                                        style={{border: 'none', background: 'none'}}
                                    >
                                        <Icon name="edit-2" color="#0d6efd" size={16}/>
                                    </button>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <Popconfirm
                                        title={`Delete scene`}
                                        description={`Are you sure to delete this scene?`}
                                        onConfirm={() => handleDeleteScene(sceneDetail.id)}
                                        okText="OK"
                                        cancelText="Cancel"
                                    >
                                        <button
                                            style={{border: 'none', background: 'none'}}
                                        >
                                            <Icon name="trash-2" color="#dc3545" size={16}/>
                                        </button>
                                    </Popconfirm>
                                </Tooltip>
                            </div>
                        </div>
                        <h5>Steps: </h5>
                        {sceneDetail.steps.map((step) => (
                            <>
                                <div key={step.id} className="stepContainer" onClick={() => setStepIdActive(step.id)}
                                     style={
                                         {border: step.id === stepIdActive ? '1px solid #0d6efd' : '1px solid #fff'}
                                     }>
                                    <div className="step-header">
                                        <h4></h4>
                                        <Popconfirm
                                            title={`Delete step`}
                                            description={`Are you sure to delete this step?`}
                                            onConfirm={() => handleDeleteStep(step.id)}
                                            okText="OK"
                                            cancelText="Cancel"
                                        >
                                            <Button
                                                type="text"
                                                danger
                                                shape="circle"
                                                className="delete-button"
                                            >
                                                x
                                            </Button>
                                        </Popconfirm>

                                    </div>

                                    {/* Background and BGM */}
                                    <div className="background-section">
                                        {step.backgroundId && (
                                            <div className="outfitItem">
                                                <span>
                                                    <>
                                                    {episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl.includes('.mp4') ? (
                                                        <video controls style={{width: '100px'}}>
                                                            <source
                                                                src={episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl}
                                                                type="video/mp4"/>
                                                            Your browser does not support the video element.
                                                        </video>) : (
                                                        <Image
                                                            src={episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl}
                                                            style={{maxWidth: "35px"}}/>
                                                    )}
                                                        {"  "}
                                                        Background: {"  "} [{episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.name}]
                                                        </>
                                                </span>
                                                <button onClick={() =>
                                                    handleStepChange(step.id, 'backgroundId', null)
                                                } className="delete-button">
                                                    x
                                                </button>
                                            </div>
                                        )}
                                        {step.soundId && (
                                            <div className="outfitItem">
                                                <span>
                                                <audio controls>
                                                    <source
                                                        src={sounds.find((sound: any) => sound.id === step.soundId)?.soundUrl}
                                                        type="audio/mpeg"/>
                                                    Your browser does not support the audio element.
                                                </audio>
                                                    {"  "}
                                                    Sound: {"  "} [{sounds.find((sound: any) => sound.id === step.soundId)?.name}]
                                                </span>
                                                <button onClick={() =>
                                                    handleStepChange(step.id, 'soundId', null)
                                                } className="delete-button">
                                                    x
                                                </button>
                                            </div>
                                        )}
                                        {step.outfitItemId && (
                                            <div className="outfitItem">
                                                <span>
                                                    {step.outfitItem?.imageUrl &&
                                                        <Image src={step.outfitItem?.imageUrl}
                                                               style={{maxWidth: "35px"}}/>}
                                                    {"  "}
                                                    Outfit: {"  "} [{step.outfitItem?.name}]
                                                </span>
                                                <button onClick={() =>
                                                    handleStepChange(step.id, 'outfitItem', null)
                                                } className="delete-button">
                                                    x
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    {/* Narration/Input */}
                                    <Form layout="vertical" onFinish={() => handleSaveStep(step.id)}
                                          className="narration-section">
                                        <div className="step-actions">
                                            <div className="step-type">
                                                <Select
                                                    className="character-select"
                                                    value={step.type === 'ai' ? step.ownerId : step.type}
                                                    onChange={(value) => handleStepChange(step.id, 'type', value)}
                                                >
                                                    {typeStepOptions.map((option) => (
                                                        <Select.Option key={option.value} value={option.value}>
                                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                                {option.icon}
                                                                <span style={{marginLeft: 8}}>{option.label}</span>
                                                            </div>
                                                        </Select.Option>
                                                    ))}
                                                </Select>

                                                {(step.type === 'ai' || step.type === 'user') && (
                                                    <>
                                                        <span>Thought:</span>
                                                        <Switch
                                                            checked={step.isThought}
                                                            onChange={(checked) => handleStepChange(step.id, 'isThought', checked)}
                                                        />
                                                    </>
                                                )}
                                            </div>

                                            <div className="action-buttons">
                                                <Tooltip title="Add Background">
                                                    <Button icon={<PictureOutlined rev={undefined}/>} shape="circle"
                                                            onClick={() => {
                                                                setOpenBackgroundPopup(true)
                                                            }}
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Add Sound">
                                                    <Button icon={<SoundOutlined rev={undefined}/>} shape="circle"
                                                            onClick={() => {
                                                                setOpenSoundPopup(true)
                                                            }}
                                                    />
                                                </Tooltip>
                                                {(step.ownerId || step.type === 'user') && (
                                                    <Tooltip title="Add Outfit">
                                                        <Button
                                                            icon={<SkinOutlined rev={undefined}/>}
                                                            shape="circle"
                                                            onClick={() => {
                                                                setSelectedCharacterId(step.ownerId)
                                                                setOpenOutfitPopup(true)
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </div>
                                        </div>

                                        <Form.Item>
                                            <Input.TextArea
                                                value={step.content}
                                                placeholder="Enter content"
                                                onChange={(e) => handleStepChange(step.id, 'content', e.target.value)}
                                                autoSize={{minRows: 2, maxRows: 4}}
                                                className="narration-input"
                                            />
                                        </Form.Item>
                                        {step.options.length === 0 && (
                                            <div className="ending-actions">
                                                <div className="ending-switch">
                                                    <span>Ending:</span>
                                                    <Switch
                                                        checked={step.isEnding}
                                                        onChange={(checked) => handleStepChange(step.id, 'isEnding', checked)}
                                                    />
                                                </div>
                                                {step.isEnding && (
                                                    <div className="winning-switch">
                                                        <span>Winning:</span>
                                                        <Switch
                                                            checked={step.isWinning}
                                                            onChange={(checked) => handleStepChange(step.id, 'isWinning', checked)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {step.isUpdate && (
                                            <div style={
                                                {display: 'flex', justifyContent: 'end', marginTop: '1rem'}
                                            }>
                                                <Button type="primary" onClick={
                                                    () => handleSaveStep(step.id)
                                                }>Save</Button>
                                            </div>
                                        )}
                                    </Form>
                                </div>

                                {step.id === stepIdActive && !step.isEnding && (
                                    <div className="toolbar-container">
                                        <div className="line"></div>
                                        <div className="toolbar">
                                            <div className="toolbar-item" onClick={() => addStep(step.id)}>
                                                <Tooltip title="Add Step">
                                                    <div className="icon">
                                                        <Icon name="message-circle" color="#28a745" size={16}/>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div className="toolbar-item" onClick={() => triggerAddScript()}>
                                                <Tooltip title="Add Script">
                                                    <div className="icon">
                                                        <Icon name="file-text" color="#28a745" size={16}/>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            {
                                                sceneDetail.steps[sceneDetail.steps.length - 1].id === step.id && (
                                                    <>
                                                        <div className="toolbar-item" onClick={() => addScene(step.id)}>
                                                            <Tooltip title="Add Scene">
                                                                <div className="icon">
                                                                    <Icon name="bookmark" color="#28a745" size={16}/>
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                        <div className="toolbar-item" onClick={() => addBranch(step.id)}>
                                                            <Tooltip title="Add Branch">
                                                                <div className="icon">
                                                                    <Icon name="git-branch" color="#28a745" size={16}/>
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                        {step.options.length === 0 && (
                                                            <div className="toolbar-item"
                                                                 onClick={() => setOpenLinkModal(true)}>
                                                                <Tooltip title="Add Link">
                                                                    <div className="icon">
                                                                        <Icon name="check-circle" color="#28a745"
                                                                              size={16}/>
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                        </div>
                                        <div className="line"></div>
                                    </div>
                                )}
                            </>
                        ))}

                        {sceneDetail.link && (
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        borderRadius: "10px",
                                        padding: "10px 15px",
                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                        width: "100%",
                                    }}
                                >
                                    <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <div
                                            style={{
                                                backgroundColor: "#ff9429",
                                                color: "#fff",
                                                padding: "5px 10px",
                                                borderRadius: "5px 0 0 5px",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Link
                                        </div>
                                        <span style={{
                                            color: "#6b46c1",
                                            fontSize: "16px"
                                        }}>{sceneDetail.link.nameNext}</span>
                                    </div>
                                    <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <button
                                            style={{
                                                backgroundColor: "#9d6efb",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "15px",
                                                padding: "5px 15px",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                            }}
                                            onClick={() => {
                                                if (!sceneDetail?.link) return;
                                                const targetScene = nodes.find((node) => node.id === sceneDetail.link?.idTo);
                                                if (targetScene) {
                                                    setSceneDetail(targetScene.data);
                                                }
                                            }}
                                        >
                                            Go to
                                        </button>
                                        <Popconfirm
                                            title={`Delete link`}
                                            description={`Are you sure to delete this link?`}
                                            onConfirm={() => handleDeleteLink()}
                                            okText="OK"
                                            cancelText="Cancel"
                                        >
                                            <button
                                                style={{
                                                    backgroundColor: "#dc3545",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: "15px",
                                                    padding: "5px 15px",
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                }}
                                            >
                                                x
                                            </button>
                                        </Popconfirm>

                                    </div>
                                </div>
                            </div>
                        )}


                    </div>
                )}
                {sceneDetail && sceneDetail.type === 'branch' && (
                    <div className="detailContainer">
                        <div className="scene-header">
                            <div className="scene-info">
                                <h2 className="title">{sceneDetail.name}</h2>
                            </div>
                            <div className="scene-actions">
                                <Tooltip title="Update">
                                    <button
                                        onClick={() => triggerUpdateScene()}
                                        style={{border: 'none', background: 'none'}}
                                    >
                                        <Icon name="edit-2" color="#0d6efd" size={16}/>
                                    </button>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <button
                                        onClick={() => {
                                            setOpenDeleteBranchModal(true);
                                            setBranchDeleteId(sceneDetail.id);
                                        }}
                                        style={{border: 'none', background: 'none'}}
                                    >
                                        <Icon name="trash-2" color="#dc3545" size={16}/>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                        <h5>Text: </h5>
                        {sceneDetail.steps.map((step) => (
                            <>
                                <div key={step.id} className="stepContainer">

                                    {/* Background and BGM */}
                                    <div className="background-section">
                                        {step.backgroundId && (
                                            <div className="outfitItem">
                                                <span>
                                                    <>
                                                    {episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl.includes('.mp4') ? (
                                                        <video controls style={{width: '100px'}}>
                                                            <source
                                                                src={episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl}
                                                                type="video/mp4"/>
                                                            Your browser does not support the video element.
                                                        </video>) : (
                                                        <Image
                                                            src={episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.backgroundUrl}
                                                            style={{maxWidth: "35px"}}/>
                                                    )}
                                                        {"  "}
                                                        Background: {"  "} [{episodeBackgrounds.find((bg: any) => bg.id === step.backgroundId)?.name}]
                                                        </>
                                                </span>
                                                <button onClick={() =>
                                                    handleStepChange(step.id, 'backgroundId', null)
                                                } className="delete-button">
                                                    x
                                                </button>
                                            </div>
                                        )}
                                        {step.soundId && (
                                            <div className="outfitItem">
                                                <span>
                                                <audio controls>
                                                    <source
                                                        src={sounds.find((sound: any) => sound.id === step.soundId)?.soundUrl}
                                                        type="audio/mpeg"/>
                                                    Your browser does not support the audio element.
                                                </audio>
                                                    {"  "}
                                                    Sound: {"  "} [{sounds.find((sound: any) => sound.id === step.soundId)?.name}]
                                                </span>
                                                <button onClick={() =>
                                                    handleStepChange(step.id, 'soundId', null)
                                                } className="delete-button">
                                                    x
                                                </button>
                                            </div>
                                        )}
                                        {step.outfitItemId && (
                                            <div className="outfitItem">
                                                <span>
                                                    {step.outfitItem?.imageUrl &&
                                                        <Image src={step.outfitItem?.imageUrl}
                                                               style={{maxWidth: "35px"}}/>}
                                                    {"  "}
                                                    Outfit: {"  "} [{step.outfitItem?.name}]
                                                </span>
                                                <button onClick={() =>
                                                    handleStepChange(step.id, 'outfitItem', null)
                                                } className="delete-button">
                                                    x
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    {/* Narration/Input */}
                                    <Form layout="vertical" onFinish={() => handleSaveStep(step.id)}
                                          className="narration-section">
                                        <div className="step-actions">
                                            <div className="step-type">
                                                <Select
                                                    className="character-select"
                                                    value={step.type === 'ai' ? step.ownerId : step.type}
                                                    onChange={(value) => handleStepChange(step.id, 'type', value)}
                                                >
                                                    {typeStepOptions.map((option) => (
                                                        <Select.Option key={option.value} value={option.value}>
                                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                                {option.icon}
                                                                <span style={{marginLeft: 8}}>{option.label}</span>
                                                            </div>
                                                        </Select.Option>
                                                    ))}
                                                </Select>

                                                {(step.type === 'ai' || step.type === 'user') && (
                                                    <>
                                                        <span>Thought:</span>
                                                        <Switch
                                                            checked={step.isThought}
                                                            onChange={(checked) => handleStepChange(step.id, 'isThought', checked)}
                                                        />
                                                    </>
                                                )}
                                            </div>

                                            <div className="action-buttons">
                                                <Tooltip title="Add Background">
                                                    <Button icon={<PictureOutlined rev={undefined}/>} shape="circle"
                                                            onClick={() => {
                                                                setOpenBackgroundPopup(true)
                                                            }}
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Add Sound">
                                                    <Button icon={<SoundOutlined rev={undefined}/>} shape="circle"
                                                            onClick={() => {
                                                                setOpenSoundPopup(true)
                                                            }}
                                                    />
                                                </Tooltip>
                                                {(step.ownerId || step.type === 'user') && (
                                                    <Tooltip title="Add Outfit">
                                                        <Button
                                                            icon={<SkinOutlined rev={undefined}/>}
                                                            shape="circle"
                                                            onClick={() => {
                                                                setSelectedCharacterId(step.ownerId)
                                                                setOpenOutfitPopup(true)
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </div>
                                        </div>

                                        <Form.Item>
                                            <Input.TextArea
                                                value={step.content}
                                                placeholder="Enter content"
                                                onChange={(e) => handleStepChange(step.id, 'content', e.target.value)}
                                                autoSize={{minRows: 2, maxRows: 4}}
                                                className="narration-input"
                                            />
                                        </Form.Item>
                                        {step.isUpdate && (
                                            <div style={
                                                {display: 'flex', justifyContent: 'end', marginTop: '1rem'}
                                            }>
                                                <Button type="primary" onClick={
                                                    () => handleSaveStep(step.id)
                                                }>Save</Button>
                                            </div>
                                        )}
                                    </Form>
                                </div>
                            </>
                        ))}

                        <h5>Choices: </h5>
                        {sceneDetail.steps[0].options.map((option) => (
                            <>
                                <div key={option.id} className="optionContainer">
                                    <div className="option-header">
                                        <h4></h4>
                                        <Popconfirm
                                            title={`Delete option`}
                                            description={`Are you sure to delete this option?`}
                                            onConfirm={() => handleDeleteOption(option.id)}
                                            okText="OK"
                                            cancelText="Cancel"
                                        >
                                            <Button
                                                type="text"
                                                danger
                                                shape="circle"
                                                className="delete-button"
                                            >
                                                x
                                            </Button>
                                        </Popconfirm>
                                    </div>

                                    <Form layout="vertical" onFinish={() => {
                                    }}
                                          className="narration-section">
                                        <Form.Item>
                                            <Input.TextArea
                                                value={option.content}
                                                placeholder="Enter content"
                                                onChange={(e) => {
                                                    handleOptionChange(option.id, 'content', e.target.value)
                                                }}
                                                autoSize={{minRows: 2, maxRows: 4}}
                                                className="narration-input"
                                            />
                                        </Form.Item>
                                        {option.isUpdate && (
                                            <div style={
                                                {display: 'flex', justifyContent: 'end', marginTop: '1rem'}
                                            }>
                                                <Button type="primary" onClick={
                                                    () => {
                                                        handleSaveOption(option.id);
                                                    }
                                                }>Save</Button>
                                            </div>
                                        )}
                                    </Form>
                                    {option.nextStepId && (
                                        <div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    backgroundColor: "#f5eaff",
                                                    borderRadius: "10px",
                                                    padding: "10px 15px",
                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                    width: "100%",
                                                }}
                                            >
                                                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                                    <div
                                                        style={{
                                                            backgroundColor: "#9d6efb",
                                                            color: "#fff",
                                                            padding: "5px 10px",
                                                            borderRadius: "5px 0 0 5px",
                                                            fontWeight: "bold",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {nodes.find((node) => node.id === edges.find((e) => e.id === option.id)?.target)?.data.type === 'normal' ? 'Scene' : 'Branch'}
                                                    </div>
                                                    <span style={{
                                                        color: "#6b46c1",
                                                        fontSize: "16px"
                                                    }}>{nodes.find((node) => node.id === edges.find((e) => e.id === option.id)?.target)?.data.label}</span>
                                                </div>
                                                <button
                                                    style={{
                                                        backgroundColor: "#9d6efb",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "15px",
                                                        padding: "5px 15px",
                                                        fontSize: "14px",
                                                        cursor: "pointer",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                    }}
                                                    onClick={() => {
                                                        const targetNode = nodes.find((node) => node.id === edges.find((e) => e.id === option.id)?.target);
                                                        if (targetNode) {
                                                            setSceneDetail(targetNode.data);
                                                        }
                                                    }}
                                                >
                                                    Go to
                                                </button>
                                            </div>
                                        </div>


                                    )}
                                </div>
                            </>

                        ))}

                        <div className="AddChoice___1Vrgo" onClick={addOption}><img
                            style={{width: "30px", height: "30px"}}
                            src="data:image/png;base64,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"
                            alt=''/>Add Choice
                        </div>


                    </div>
                )}


                {!previewEpisode && (
                    <Tooltip title="Preview Episode">
                        <img className="preview"
                             onClick={() => {
                                 if (!sceneDetail) return;
                                 setStepIdActive(sceneDetail.steps[0].id);
                                 setPreviewEpisode(true);
                             }}
                             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAB8CAYAAACrHtS+AAAgAElEQVR4Xu2dCXxU1fXHf/dNJgtJCAECyqIogoCCKCqgaMUdqLugKIKCuGu1ttaq/4rWahertrVWLCigiGvFBVDABQVBBUUQZBFEWYSEEEK2CTN59/85973z5s7LTJJJZovkfT46k2Eymfe+93fuOeeee55Ay3FAXQFxQJ1ty8miBfgBNghagLcAP8CuwAF2ui0KbwH+c7oCspEDWsif01XQz6WRFyTVLkco2FjRqn1xmv9AaKbAg4DrgjsJELg/ysH5ADAJiPixoRes+Q2AZgS8bsiT7q8dYk4C8Ora6ELPkX0g6ffcx6QHag+C5gi/GQC3QLslpwN2gz1/KrqnZaCPBHoLgV4Q6GYAeRBoDSAXQHsb6G4AZZDYZwKlkNgiJdYJYG2gGt++NQGbGLx7ILgHQPBCprbqUxR4wyGPeAodM1pjkAQGegwMgsDxUqKVAqWdHT2VEQy1EK4BZb9PCFRAYkWNiaUC+My3F5/OvQW7mzP8FANeG3Q4JZ/xMLJzu+CytDSMh8AgBVIRDTXE9Lp+gnUB599UH+W+KvZnq9cllgUCmLJnA176+CH46oKfiqpPIeAyxBbqDtdR9jw84r/on9kKNwkDoySQowNmuOHgu0HzSbsFHwJag1xrEAg1kEqliZm+Sjw7ZyJW0oBZ08f+Ri7Hz/p7qWHqUwB4/aDPexZDMjJxlxQYzqbZAczilpbJpn/37QNMP1C5BwhUSvirLP0GquA8Z0V7s4C0LOsn9byVQKu2gOEFMltbRoMGApt9NiQhr0nMrfbhr2+Px+JUB59E4KHmO5yiL56G4fDid8LAyXTldcj6zwS4qpj+kwoywY7FQdAJflY7gax2oQOARpYOn36QJpbAj0f+dzXejQQ+2WY+ScBdqrZDKjbdwyajd1YOnhEGBjPYkPlZWkot3Qrs2xpUcCwg1/UZZAFadxXI62pZgxAHwbYCNvilVeW4bt71+FYHr3v2yTLzSQAehM2q5rBq4P+hdZcjcQ88uB0SaQq2HZOpeVgC+7YBJZskqsvijbfuz8/IBfK7C7TuYoFX87+tejUQBAKoweMbv8AfV/0DlY5zp83vyYCeQOAuE+5S9YVTcJwnG7Mg0Z3hKtYMeiuwe33i1NzQ4URKb3+kQOuuGng7JLQHwaaaCoyefS2+DKf2RJv4BAGvbcJZ1WuKIP7wHn4NDx6ChJdNeAjodakH2j0gFPheoeBZ9RDwI4B7HjwXTxxVAMlqZxOfSOgJAF7bhDth1t/QIaMTpguBs5zQicy4CVTvA3atlqikXFgzOlq1Bzr2FchoDQgjOM8rL19iQfUOjJvzWxQ6ak+wiY8z8MiwL5iM3mmt8S4kOuuqJvCFqyT2OEnNZkRb+6oFvQXa9QqGdJratwX2Yfib12NtMqDHEXh42GTC73sHZxoZeElK5LH3TaoOVAI/LpWoLm2ekN3fOiMPOGSwQForW+323G4YKK2pwkUPnYdPyMSrhE2ClB4n4JFh3/sOxngyMAUSHjp/07QuU9k2YPsKGbMYOlWGDMXynQcI5JI3D8AgM2+Br67Zj1v+NALTEgk9DsA12PdD6M7Zve9ioseDp/TYWpnwNcDub2NVtpAqqEO/x0HHCLTtoYVvdhhXE8C4Pw3Di5GdudimZGMMPDzsgiKIwXMw3JuONyBhsAdOj9s/l9j7Q2pCivW3anMo0PlEEYzZ7Xg9sB8jHx6Bd9zQ4+G9xxB4MM7mFS7yxgn2oNk4NT0bc6SJTBVbm1Z8veMAgs2DR0EfaKdcbPMuDPiq92HoZ5dgeRHP6QAobIs19JgCJ6PM2TOGfcLL6JPVFoulqQoPHNhK2VtiraHm8XltugWVTqGb7cEXV+3BGV9chjUOdNuRi2VGLkbALVOuwyZvfOJfkHfwsVgOoBspmpW9/bMDF7ajdII+0DLvDnRg865VGDj5N9jLjlxocqbp83kMgIfO26Rsgt2pDGLCp5gpBEbqsAtXS+WktRzAQf0F2nOsbitdSrz6yTm4glTOcXosoTcReGQn7eQ5GOfxYooOe99W4MfFP29vPNqBfMgQKx2rK73Gj2uXjMB0gh4+Ddt4pccEuHve7j0Fbdsfgk0CyGEz7isDvpv384uzowXsfj/F6UcME8jMDUKXQFnxNvR4ajyK3TF6U+fzJgCPYMp7Qkz4F6ZC4CqCrWJuE9gwR8L3M8mgNRWy+/cz84CeI4STe1c5eInnp96KCTs2QMZyPm8ycArBOLlSshnG2PdxqjcLC5VHTrBrgO3LJYrXx/oy/bw+r8PRACVnhCeYf/dX4pzpZ+DD/MNh6qa9KSpvJPDa6qZ4+8g7kV5wNr4SQE9Wd0UxsHFuy7zdkOHZY7hAdjt7Xd1QxnH9+ofRr2gRTA7VmurANQq4tPMBpG7dK7/mY4w1vJgCO7FC0L+bL1GxqyGn2/Ke7I7AEWdbpl3F5oaqz7v2uVMxY0duONMevfPWCOC1Y25Sd1EBjIuexzdCoIdy1EygeCOw9dMWdUczlLueJNCuhwWbFloEsOH1MehbUBRUOa+sNca0Rwk8sqN21V9xQXoWXmWvnB7Xvibhr4jmdFve680G+lwaVDmpvboC579wN96NhQPXKODuMEypewY+gcCJNPHQkueejcmLuanAkMKdqj3NcwBRbE4ra2oplQhJfPLGWJwZC5U3Drg+d/eEuPIRnJaZg/lsysk7X/NK4tWdfRDQ8WgBUgkf/kqgeJ1E2U+AGWgeA4C+/1GjtLSrAVSW4tRZ92GZW+XRmvUogIf3zEndF07HVGFgDMfcReuBrQnOqFG5cKfjrTphew+YomvXkqnCip++lqBsX3M4ug4RKDgyWBcnTbwwexwm6CpvjMceNfAQz7wnxInDkN13OLZJE9kcin37hkyoOaWtQoefKeDx2iaQobvIkuWpLgF2rpKoLEpt7Fltgd4XhSRjyuY9goN27IC/KSpvMHB3KMae+QVTMMrIwPOsbtr2s+blxHrmbY+wFiJY3c4+MO3sQjYbwtrQsHOlBJn8VD2Oukyo/W1c/Wr6MPLNiXgrvMobFqI1ELgditlZtUmLYHTqCVG9FcaNb+BVSJzHwKku7SdVcp+447ChAtkdguVDbMr1rUBu4Mq53A8UrreygKk4vx98nFUP55Q7C7z9n4swMqMrTFL5pF/ApCxnsFCifuhRA+fChg09IU4+Bhm9rsVuaSKDHbbVsyT2lycONv2l7mdbm/14xSkccPWN7A2J/Jx/9pcDO1en3hp9eg7Qd7QdolFMbsD33QvosOgz+HpugNSzbw113hoEPJI5H/40TsvMxnsUhhHwikKA5u9EH32vcBUSaHu9Qr6LGzhX4NiVsxU7gZ3fSHUeqXLQPK6sl52I8VXgnLk34KPGmvUGAA9m1ibdD+jm/PpX8H+GF/fSAgkB3/k1sG1Z4oH3G6M5N6EVJGHbfoTsXbPTwHolLW2C2LFcpoSZ7zJI4KBj7KoYj0q1/mnyKPwxxKxHUQrVcOB27E3OWm5PiMKtMM58HQuEwClszje+mxyz2H9csBKUkhVU+afy0cq2B7Wqchj2eFQRha1wfuRiDfq5phooWiexa1VytU71bz3ODZp1KfHJwktwVoeuMMsaYdYbBZxi707HI2PQr1BkavP3l89K5Qgl+uh/tbCyUtY8FzKXq+9in2U0wDlFHCgDti2XyqtPxmGkA8eNDwI3DPiWP4OOP34Cn9usN2Qerxc4z9+4H4J6ntGad/7hEGf9E4Nz2uAjVjfNe2teS7w5JwjHjreAszdr0J6WSLE4ZyvrUTjnFNjUl+8Etn0u4dubeOxHXRqcx+kcy/fitAW3YWnJZkheK4fdR07U00umHuDBcMxZBrXDsYmzMNaTgWfUBamB2vz33btJAj5BwEOQdYWrjUyhoZqzj83ecx7OpDsbG7lax34vm/vd3wI/rUxsqVav8+26N3sg11Tjuv+Oxgyex/WKmPpUHhVwff4e+jL+kObFPazwrUsldlBBchKOAdcJkKodhevm3TWP1+oToyld3xGjnmvr+s7gkEDAZ0En+Ik4Oh0PdB0cNOsBPx7+8DI8uLUrzGjDs6iB0/xdUQRjzBw8LwUuZeCb50vsTlIZ04AbLOC8uqTA81zO87f9GNLWy24p4tTe6Wq2gRNQs8bGygPArtPbXwZsfl/CVxJf7O2PBA7nwgg6NxMvzPwlJmYXwIx2Hq8TeKT4uyIbxpVP4m1h4Ey6WHRB1r4uUbYjvice6dNPuCkkOWE5blw1Yiu8VrM9V0xuarApX6V+ttVP58cOnzpfep0tgwR++Fhiz3fxO/fcTkCfS4JWTJpYOPMWnJddURu4dbqRM251ANfadLDDlg8jv0Sdu+fCaVgE4ARW+DevSpT/FL+TruuTT7wpeDEUaHba7L1bKlTT+rk5njtDVvbayiWowx4MejEHnTQnmMLN81sWxQ96zsHA0SODgxrAF7Ovxi8oeizJh8wvsYocG+K41Qucq1L1hMtBOTAumI6VVKxIOWi6MCufS15npRNuDgWuPHa7+tOJw7m5HvdRdfdeZVVrSg/Z1qyZc1K3UrltBdRAkMA3L8WnBoAKOvpfYwE30tSf3fDmOPTfWQ4z2rx6o4FfNB1bTIkOyrExgaVPJMdDJ0EOvDUUuArJuNyXlK31WmGlOxZDM+16Bs69h53n+RCVa04d/fuOOC4cDb7dziYSdIHCN8ahW9yA84IJZ9jKc1RJUwkvmtActyyZwG9zmXRd4docruZhzWt35mW7ZSf3hOP+cO5YXDfxarWNnDl7KqCBUL4DWP92fAb+oNtDzrH6jbHIJ+AnRZlxa5DC3cC3psEz/hXsIeB00krhj/MEmPh5fNCvDCcscxw2Num6wtmcs8fOX5UZhVG7011K99Dtc3b2zdnmvXCtxJaP4gN88B2GZdKt8LP62VFo2zWAmmhTrFEBp5AspxyCgF/zEnZQUx522pY+lkTgtzcMuKNwLcXOYZqudj1B43js2nZnJ4yrCXXkNi2ktfU4Af+1BdyOPgqfuxyHEfDyHMhoQrOogVMMvj8XxjUv4Xsp0YGBr3jGTFo7TBr9nHipS+E6cFc+xmIcRuluj91tyvn8KeW6ckZ8Bj05bQOuCwKHwI/TLkfv9DKY0cbijQZ+9SzVI1xtOiDHbfVLZtIWGAb/OjrgXNioQ3d0qXdtdnns7I2zo8qwqdHv2tfMuDURpALNvpeTPXfaf22cNhr9Ew38I47D6QKsmpU84Cfd2Tjg+mh3A6+ldrvenp00hl22k9YQ4gebBiUB7zc6BPgX00bjtIQCHzcTrwgDI5y18DnU2SE+81d9buBJv4kOOH8eAw9Jt3LixZWMcefWqfiRiiR+XBL/c+5wlEAPezsxTVnSxJzpV2JUQoCz03bVDDzk8eIOBk7pRVpAScZx8m8bBpxVq6dZdWU7WTaez7WMm3rJzjnsWiWx5WOp+sEm4qCFk0NPDWbaavx4/PmxuC/uThvH4eSlj3kWV3lb4WkOy0p/AFa9GB+npb6LOuR39QPXEy7OHM53NQhzt4VwiRfavbJpvpnwvnL9rjCQd6hd1+YBlVbf8MJ4PB/3sExPvJzzGE7Laou5vHhCefSvnksS8LvDA+eB4qyiaber0qtf9GpWd70bfQZtiKTyLVJ2Mo5jrzFA+XSORCqKcPqC32JZ3BIvqvZZq0WnXHqXwcgacD22w0QmQ6dYPFCd+Etyyu+DwFValRMUvDTKiyeumMSBy/FamOXS7z+0piqqcUvGkZYB6FEIDPhWTEbnbUtRFbfUajjgRYDn2ufwoTRxPCcivnnFVLtGE30M+b2hKl6cGFxLrSpTzkulfEsN/TZnEWrVd68FNswzk1LSpF8/2kV69CirIlOtCQCLp07AsAKgJsbAKQ9hd34MszzqK4Vx6Uv4m8eLG1nh25dJbHo/8Wbv1Hs0k85Lo9riiX0PkmBixVa0e7GE1sB9e6i23kTJ94ketuH/XvczBDoPCubRa6rx59euwEOZeWpFPpbLo0HgvIGQ95NRAYRnBzwXPYfzMvIwix03KoD4cmri5/FT79PSjnbBPle8qOQKAdYrXtgL1+6pQmHW5g8ktiUp0og0vI6bYIAKIHia8pXg4tkTML+mE2piXAChrorVUlOrSecSp/a5MA6biPY9Tsf30oSh1ohp1exfZsIb3B9zlYH8w1wmnTsb8uIJQw6j7q1LLMtEtWqpdFCD/UG3WtbLzrKZGxai25apKN7diLSqGvx1n2Bt4LSnrOtWGBSa5WfCOH8q5gmBIazyLR9K/PBJYs36kecLHHysFWNxfbq6SPYRcldB7auVbAbWv2MmrVKnvsF16CkC3YbahQ8eVWSx+K0JGFbig0khWdyLGFUPVbtMmTx1ctzGPokx6a3wH7XdSAKVxcBn/0qsWe/YTzh7qZ0WlsE7D4TcPJa+I7UC2TjHRKG660jqHgNvNdDKbuNFA3h/JW6ccQtecDtsMSxTDuO42RsRtgGe9qUwel2A3GOuwkYprTabpPTlT5sJ35A34HoDuRSraiXKjgmz4at7qiyRqtI01Y+8Q4D+V2vOqEDFV8+i+4a5KN+dB7MLOWyx34hQ/zxeKOAZPQ2TjTSM5tQjlfqsfyuxFzWnI23JMdSNY7nHGWfU6HHHlxLr35GoSbF5OtLAo2mqk703nBw2M4BZs67G9R0kaho7fzdgDg8PXE+x0jx+5p/xi+wOeIeBk8qpAibRvVXTMgFqDtC6kwA9p2QJVaFs/7L5gKYrTr1X3Wv8FYX45cK7sYjn72grXRx/pn7TFnm7MM3jvkwYxm54LnkRc+kuwLrK172ZWJXXfy7N4x29LghVN921+PUrMNxsj5pMH8xaCZfYbheuOx5vXwyDzPqFj+Ps7AK8xsDpccnfEx+iNQ+kkb8lhWIn3xmaV6gowqWz78D8usy5Za7j3PKDwjOqYKWNCfvLYVw6C1TCdyxD/2mFxLezW1QezSDsdWGougXw9WujcWp6jpVZyymH2ZhwLAqTHjqPu/PquR0hKOuWlwlj6JMYmd4GUx2V1wAr/pv45cRoLnAqvZfueDRgomHV1NvlTNV7MOaj2/BWqQ8mZdfKdkFGu/lAP8d6Ei/Bt0baZ8YFEeS8ebORds4T+EDYKqcxSXH5p39PbFyeShCj+S5UqqXibhu2BFa+dzuG+isQYGctXJVqQ815A710/sqR94or560UBqn8pIdwXG43vC9NeDjdummBBC0zthyRrwBFF93PshvkW8Br9m3B6Uvvw1ekblos0Z21aJItjVI459Xpl8Pl1ql0mVRO8/mwJ/HntAzcwBWtVO257B9mS9/0CLypT7raTKEljQLVeHreLbhbrYj5YEaqXwuqtn6HLUqF147J3alWVnnBMLQ+9gp8DYl2PJ/TfcCX/dNMWiFBqloXTwYw6DYDdN9xnrchsGPFDJxQvABlsVR344FTBHA/wFuQeAWNVV4CeC5+EKfkdsKbtJLmFP+tBla90DKf64Ov3xgDHfuGrPSZZdtx/v/ux+L8OtTd2Cb5DXbarC8ZuUE+teHkudxPyRgDnpGT8fu0TNylZ+CoupXucNRyANSsp9MJoRshAz789dXr8YhposZbz9wdrTlvhMI1sx5G5eSxU1xOq2h55TCEAc/Fz+NNGMFebgSf9lFTbvtAPjodJ3D05aGdK2Bi8f+uwvnSRE1pDkxaFaO42+2ZN1bdjQReO/PGt56kdl5UDUPZtyrbget1Idr1GI751BJVrabZOy0V9BUHJnRaFCHYvH5v16pt2jgXZ6+bjWJy1LJ8MHe3g0lVLbQqlsSb3IQ37dzh6VPNtFOYtseA5/Q70b2gL96DiXb6Vp3VL1PnpwMLOjXx73uZ1r6DJlUDxUWrcc4Hf8cmtykPt/+7MaacrWmUc7huhENbautN+9i088KKPwPG2ZNwYrvD8I5pwkvFEgx+NSn9AIGuYNtmnLtUGAb8xd/jl/Mn4XNvNUxeIGFTrq95R9sqO9yU2WTgelzOYRo1/uFtxRSbU56d5vNh/8YVWW3wJDfzY/P+/aLEr58n2n84epRAF7pRvF2GxY2Hqvbilnk340Watylfrsfc1LAnFncyamTiJdwlCn/fcC6Dojw7z+cUquVUwhj+FMZm5uFRSKSR0hk6NbGlHajJKviP1wCgOJt2fnbsZ1UQcsMhCNRU7cXt827GzPJWMCkE43lbz5en0M1ma8/lfA9SvWMjee2UkKFQLZABg6Cf/SjOzTkYz0FaLUPUJnsT8BUDK541k9bvLdbQqbx4wHgDme2CTQPtPrDVZdsxdsFdWECw06phcghGplwvbkix20mHd+DoVa5hd+ZzG3puBgw/Qf8LTsnujBkCyHOa49h9WzfOk6D8e3M+KC/eY1jw5rFK3VYl7b7ybbhy/t1Y4m0Fs8wFWw/B6M1r+kA25u5Fka5dE+bw2g5crfm8DIJCtUjQT/kNurfrh+mGgT56yEbPq4qBVTNN1bS3OR1tuwP9rjSsW3LY7cK407M0sa5wJa5c8hi+jwQ7cgimfPMmqyBGwMMnZPT4PBL0guORddJNeNTwYrSzi1PrmEQ7QahLc1Wc+5k2dVBl5QNHnCvQhZrgcutu3tMm1A11pn76H/yhaDmqGgq7KQmWOCvcAq7+T6tprizcBlvp5LlnF0DwnH6wH6LEgCeQDmPE3zA6uy0ekUCOE6tr7TAJPJn6VANPoMl0E2ilQb1Bv+WUV+zbiRvfvRdz0/bDzDdR85MXkufsiiJIasxDyu6ZG7xxTSjs2KhbfUpTR3bo72vQtRvJ6+EaKz3LB0HZOArZKE7P9sLoNwZdOg/Cg2npuEBvgqe3tSbw1Kg+ns1sG3JN6F5pXU4MKtq5Z5oGPLAfb21bivtWz8T2Cj9MirMp9CJvvCoT0om1tfCr9o3hYwc7DsAje+4NgZ7uhyC1n/sATsntjMch0I3BK9Nh/0e7PKt2A9s+k+qmOolSPamZbjpD8XRWe9UC05KM/Z9zGy0TG/dtx53vTcKnpOr9pOgoYQfhNH3e1gdwjBXOH62tqmnm3T2nZ3WE2FAMI6sNhL80GLZ5W0FkFyB94B24JLMNbjY86M1NdVQIx/DtOWTvj8Ce7ySKN0h1z/JYbQqk2na6l3e7ngJtjxBoc4hmE8nrZti2qs0arPOV4qnPHsOrFUXY76+EdMKuPJhVeyF7toNZtQuSvHG3g8ZmPF6w46Tw+qGfBoDW0HeWQ+RWKbhqXs/Mg2ATz2qvSYMx7A8YmtMRt3rSMERV0Wh3I9LbdfBzuqEsQd+9Xipvv7LEcm7pufsW03SPT/Ko6WiVb93wrv2R1kaG1l0j3+3QXvBQc3ZNAEsqCvHvuQ9goScA061qXykklSjRfF2WBXmQ3T2R+p65EyvxhB1n4C7zrimd/oXidNqJSmlYntdLfBCBTBiZ1RCUpOnghyj2wvAGIAj86bejb9vDcGtaprr1pUef261RYA8GPXgJ91qYSdrp7KTZPPdrvM/cfvT7q/BGyRZM/uAJrCbQ/jTIdn6YhV5ISqb4MiDTfDDzXfM137aCvgbF2YlQNp9ynEy6fkXDm3cHuu3BK7V3hMiuCKo9oxqiOgOGVwfvg5GWCTH0LgzI64oL0zJxDgQOdZrg6i087A3/If3Y6oCt2oO4gXOfGGtf+Q9+H+aU/oA3P3oUKwM+SE9mELTfC5lRDbM6A9JRdTYkpUpJ1bonngzYCVB40LyzADlk4zQszetk4sOpPasags18RQ4EmXk29aR6Au8LQJx4NQ7pcDTOSGuF09K8GEKhHffp0ZUfhnXoSwzXNhYCKA/4sThQiUWF32Dh59PwY2YaJIEmNbPpJqcsuxySPHACXZUBGU7VbMLDp0sVjiYnVuo7xwQovDZ0eoUqX+mR6uLcJl6f28nMM3hSfFkuhL8CBoEn564qAEHwCTwNAPqsQdfisJzO6JnVBj0NL3oaaehKHSwNA7kQyBECbdUAlNgDiXLTRBmlPM0Atpp+bPCVYmPZNqxfNgWq0wsBJtAEOYseKyGV550NM7cMkhXNoPW5mla8aplw+47AoYqLP+wEKrxuEx9J7bqZ18GXVUNkkNpzICps1RP41q0BHgD0F32ZEDn0GAjNN9BrdLhvgkxQ6bVMn+UNMOB9+wACrZTshdxfDlnthcy1TbcDWjffNmi3qhM5X4dTewIVHh56OLVz+IYBADl1rPiSAoguAChpU9IGItMHwfBJs+n7gwOAPreqFURr+8/SQKjL3BFQ+nfqpplVaT13AKeDbAEcyJmQ+XshKXlCd6jM17xvUjRWAFySRJ+jHDNN1UGlJUbV+nknCbgyqE4qVl0M24t3m3n6med3An8EgF22c0eq7wSgxJ7r6b00ANrTox/KcNMg4BMmaxAOOqmWX99vw831Qu4GQCpW1qIUMj8Dku7URfNzRTZkx12QdPcq5ZDZiqb30n29ddC1Va2Qx32+TiGF16H2MOB1x24AgM226hl+N7rIFRD6AFDw8yAKtD9FgyHcRWCoChZBLrWA6YALsiG3ANAhH54PuQIAzdFsuiOBTqaqU0Th7kuv3SctguIZPKue4dPPjvqrKCELUHjHf4EGgv7XyCrQ4b6vHinXsQbZkNgCdMwKqpj+TYdMPzcX0HxeSTTp4bQWaubpHezNq+cAqFhSqcgO5xT8Mgie7/VP5UHAr+2iwRDmIKj8Mpto/W08L9Nqlhsyh1j8fi5WCCpaPUuK+Q53rikGnL9ibfB1wQ87AOhFMgH2Yd9RMdw1UK8pqHyQnSZTHQYwvV4X5FQFzaeWosB1LtHD598mK8DPKblT10GmmQ/Kb7vf25wh6+fSDICHqp5+CmcfddPPv6FPAfXwdv7ZDdb5LPuG7JEvXuqY7brOtRkBr636SPA14GqXa1SH3REp0u+EXrDmAbmZKrwubHabb/stsfKQaquh+QF2X7VmqvCGajZ0IDT0t1LJq274dzMYL4kAAAA5SURBVG7YO3/mwBt2EQ6kd7UAP5Box75q9QC7es3wdFsU3gyhNeUrtwBvytVrhr/bArwZQmvKV/5/NZdtmpQwVQoAAAAASUVORK5CYII="
                         alt=''/>
                    </Tooltip>
                )
                }
            </div>
            <div className="mapContainer">
                <div className="mindMapContainer">
                    <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        nodeTypes={nodeTypes}
                        onNodesChange={onNodesChange}
                        onEdgesChange={onEdgesChange}
                        onNodeClick={(_, node) => {
                            setStepIdActive(node.data.steps[0].id);
                            setSceneDetail(node.data);
                        }}
                        draggable
                    >
                        <Background gap={16} size={1} color="#eaeaea" variant={BackgroundVariant.Dots}/>
                        <Controls style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '6px',
                            padding: '4px',
                            cursor: 'pointer'
                        }}/>
                        <MiniMap
                            nodeStrokeColor={(n) => (n.style?.background as string) || '#007BFF'}
                            nodeColor={(n) => (n.style?.background as string) || '#fff'}
                            nodeBorderRadius={4}
                        />
                    </ReactFlow>
                    {showSaveButton && (
                        <div className="save-button-container">
                            <Button
                                type="primary"
                                onClick={handleUpdatePosition}
                            >
                                Save Position
                            </Button>
                        </div>
                    )}
                </div>
            </div>

            <Modal
                show={openEditScene}
                onHide={() => setOpenEditScene(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header className="bg-light" onHide={() => setOpenEditScene(false)}>
                    <Modal.Title className="m-0">Edit Scene</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form layout="vertical" autoComplete='off' form={form}>
                        <AntdRow gutter={16}>
                            <AntdCol span={24}>
                                <Form.Item
                                    name="name"
                                    label="Name"
                                    required={true}
                                >
                                    <Input placeholder="Please enter name" maxLength={25}/>
                                </Form.Item>
                            </AntdCol>
                        </AntdRow>
                        <div className='d-flex justify-content-center'>
                            <Button onClick={saveScene} type="primary" className='me-3' disabled={!submittables}>
                                Save
                            </Button>
                            <Button onClick={() => setOpenEditScene(false)}>Cancel</Button>
                        </div>
                    </Form>

                </Modal.Body>
            </Modal>

            <OutfitSelectionModal
                open={openOutfitPopup}
                onClose={() => setOpenOutfitPopup(false)}
                onConfirm={(outfitItem: any) => {
                    if (stepIdActive) {
                        handleStepChange(stepIdActive, 'outfitItem', outfitItem);
                    }
                }}
                characterId={selectedCharacterId}
            />

            <BackgroundSelectionModal
                open={openBackgroundPopup}
                onClose={() => setOpenBackgroundPopup(false)}
                onConfirm={(backgroundId: any) => {
                    if (stepIdActive) {
                        handleStepChange(stepIdActive, 'backgroundId', backgroundId);
                    }
                }}
                episodeId={episodeId}
                backgrounds={episodeBackgrounds}
            />

            <SoundSelectionModal
                open={openSoundPopup}
                onClose={() => setOpenSoundPopup(false)}
                onConfirm={(soundId: any) => {
                    if (stepIdActive) {
                        handleStepChange(stepIdActive, 'soundId', soundId);
                    }
                }}
                sounds={sounds}
            />

            <Modal
                show={openDeleteBranchModal}
                onHide={() => {
                    setOpenDeleteBranchModal(false);
                    setBranchDeleteId('');
                    setOptionNotDeleteId('');
                }}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header className="bg-light" onHide={() => setOpenDeleteBranchModal(false)}>
                    <Modal.Title className="m-0">Delete Branch</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <p>You are deleting a branch. Please select branch content (only once choice allowed) you wish to
                        retain or choose to delete all. After the branch is deleted, the selected content will take the
                        place of the deleted branch.Please think twice before you go ahead.</p>
                    <Radio.Group onChange={(e) => setOptionNotDeleteId(e.target.value)} value={optionNotDeleteId}>
                        {nodes.find((node) => node.id === branchDeleteId)?.data.steps[0].options.map((option) => (
                            <Radio style={{
                                width: '100%',
                            }} key={option.id} value={option.id}>{option.content}</Radio>
                        ))}
                        <Radio value=''>Delete all</Radio>
                    </Radio.Group>
                    <div className='d-flex justify-content-center'>
                        <Button onClick={() => {
                            handleDeleteScene(branchDeleteId, optionNotDeleteId);
                            setOpenDeleteBranchModal(false);
                            setBranchDeleteId('');
                            setOptionNotDeleteId('');
                        }} type="primary" className='me-3'>
                            Delete
                        </Button>
                        <Button onClick={() => setOpenDeleteBranchModal(false)}>Cancel</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={openLinkModal}
                onHide={() => setOpenLinkModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header className="bg-light" onHide={() => setOpenLinkModal(false)}>
                    <Modal.Title className="m-0">Select Scene or Branch</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Select
                        style={{width: '100%'}}
                        placeholder="Select Scene or Branch"
                        onChange={(value) => setSelectedLinkTarget(value)}
                        getPopupContainer={(trigger) => trigger.parentNode}
                    >
                        {nodes.filter((node) => node.id !== sceneDetail?.id).map((node) => (
                            <Select.Option key={node.id} value={node.id}>
                                {node.data.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <div className='d-flex justify-content-center' style={{marginTop: '1rem'}}>
                        <Button onClick={() => {
                            addLink(stepIdActive as string, selectedLinkTarget as string);
                            setOpenLinkModal(false);
                        }} type="primary" className='me-3'>
                            Link
                        </Button>
                        <Button onClick={() => setOpenLinkModal(false)}>Cancel</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={openAddScriptModal}
                onHide={() => setOpenAddScriptModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size={'lg'}
            >
                <Modal.Header className="bg-light" onHide={() => setOpenAddScriptModal(false)}>
                    <Modal.Title className="m-0">Add Script</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form layout="vertical" autoComplete='off' form={form}>
                        <AntdRow gutter={16}>
                            <AntdCol span={24}>
                                <Form.Item
                                    name="content"
                                    required={true}
                                >
                                    <Input.TextArea placeholder="Script Format:
1. Step:@Character Name;Content.
2. Narration Content.
Note:
1. If the character name in the input step does not exist in your current character library, the step will be categorized as a narrator by default.
2  If character name is 'user', step has type user.
3. Use a semicolon (;) to separate character names, content.
Example:
@John;Hello, how are you?
John greets his friend.
@user;I am good."
                                                    autoSize={{minRows: 15}} maxLength={5000} showCount/>
                                </Form.Item>
                            </AntdCol>
                        </AntdRow>
                        <div className='d-flex justify-content-center'>
                            <Button onClick={() => {
                                addScript();
                            }} type="primary" className='me-3' disabled={!submittables}>
                                Add
                            </Button>
                            <Button onClick={() => setOpenAddScriptModal(false)}>Cancel</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>


        </div>
    );
}

export default EpisodeDetail;
